import React, { Component } from 'react'
import {connect} from 'react-redux'
import {filterTypes} from "../../actions/filter"

import CustomCheckbox from './CustomCheckbox'

import FaArrowCircleLeft from 'react-icons/lib/fa/arrow-circle-left'
import FaArrowCircleRight from 'react-icons/lib/fa/arrow-circle-right'


 class Filter extends Component {
  constructor(props){
    super(props)
     this.state = { salesPointType: [
      {
         name:'აგენტი',
         type:"A",
         isChecked:true
     },
     {
        name:'სწრაფი გადახდის აპარატი',
        type:"P",
        isChecked:true
     },
     {
         type:"C",
         name:'კომპანია',
         isChecked:true
     },
     {
         type:"I",
         name:'კომერციული ბანკი',
         isChecked:true
     }
  ],
  filtertoggle:true
 }
}

  toggleFilter = ()=> {
    const Filter = document.getElementById('Filter')
    Filter.classList.toggle('FilterWidth')
    this.setState({
      filtertoggle:!this.state.filtertoggle
    })
  }

  render(){
    return(
      <div className="Filter" id="Filter">
        <div className="FilterContent" id="FilterContent">
         <CustomCheckbox label={'ყველას მონიშვნა'} isChecked={this.props.isChecked} onChange={() => this.props.toggleCheckbox(0)} id={1}/> 
    {       
          this.state.salesPointType.map((item,index) => {
           return <CustomCheckbox key={index} label={item.name} isChecked={this.props.isChecked} onChange={this.props.toggleCheckbox} />
        })
    }
     
       </div>
     </div>       
    )
  }
}
export default connect()(Filter)


// WEBPACK FOOTER //
// ./src/pages/SalePoints/Filter.js